import React, { useEffect } from "react";
import { isAuthenticated, isVideo } from "../../../utilities";
import ReactPlayer from "react-player";
import { Button } from "antd";
import { MdOutlineOpenInNew } from "react-icons/md";

function AdvertisementModerator({ advData, data, updateAdClickToSocket, updateAdViewToSocket }) {
  useEffect(() => {
    let timeOutId = null;
    if (advData && advData.adId) {
      timeOutId = setTimeout(() => {
        handleAdvClickOrView();
      }, 1000);
    }
    return () => {
      if (timeOutId) {
        clearTimeout(timeOutId);
      }
    };
  }, [advData]);

  const handleAdvClickOrView = (isClick, ev) => {
    if (ev) {
      ev.stopPropagation();
    }
    if (!advData || !advData.adId) {
      return;
    }
    let payload = {
      adId: advData.adId,
      moderatorSectionAdId: advData.moderatorSectionAdId,
      questionAdId: advData.questionAdId,
      accessToken: isAuthenticated()
    };
    isClick ? updateAdClickToSocket(payload) : updateAdViewToSocket(payload)
    if (isClick && advData.sourceUrl) {
      document.activeElement.blur();
      window.open(advData.sourceUrl, "_blank");
    }
  };

  return advData && advData.adId ? (
    <div className="o-hidden mt-32 flex" style={{ zIndex: "10" }}>
      {isVideo(advData.contentUrl) ? (
        <div>
          <Button
            type="text"
            icon={<MdOutlineOpenInNew className="mr-8" />}
            size="large"
            className="flex items-center bg-20 cursor-pointer"
            onClick={(e) => handleAdvClickOrView(true, e)}
            style={{ float: "right", marginBottom: "-80px", marginTop: "10px", marginRight: "10px", zIndex: "100" }}
          >
            Learn More
          </Button>
          <ReactPlayer className="mt-15" playing={true} url={advData.contentUrl} config={{ file: { attributes: { controlsList: "nodownload" } } }} width="100%" height="100%" loop={true} playsinline={true} muted={true} controls={true} />
        </div>
      ) : (
        <img onClick={() => handleAdvClickOrView(true)} src={advData.contentUrl} alt={advData.name} className="width-full height-full cursor-pointer" />
      )}
    </div>
  ) : (
    ""
  );
}

export default AdvertisementModerator;
